import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useSelectedRange (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('selectedRangeChanged', callback),
    () => state.selectedRange
  )
}
